<mat-dialog-content class="mat-typography">
    <h3 i18n>Save and continue later</h3>
    <p i18n>If you don’t have time to complete the questionnaire today, you can save your ratings and return to the session. Use the "COPY" button to grab the link then paste it into your browser to return to this questionnaire.</p>
    <mat-divider></mat-divider>
    <div class="link-info" >
        <div [innerHTML]="data.text"></div>        
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button data-test-id="saveContinueLaterCopyButton" mat-raised-button color="primary" class="saveButCls" [cdkCopyToClipboard]="getSaveContinueLaterUrl()" i18n="Copy Button|Copies the questionnaire url to clipboard@@saveContinueLaterDialogCopyUrlButton"><mat-icon
        class="white-icon">content_copy</mat-icon>COPY</button>
    <button data-test-id="saveContinueLaterCloseButton" mat-stroked-button mat-dialog-close color="accent" class="saveButCls" i18n="Close Button|Button to close Save and Continue later dialog window@@saveContinueLaterDialogCloseButton"><mat-icon>close</mat-icon><b>CLOSE</b></button>    
</mat-dialog-actions>
